/** @file Maps a flat [x0, y0, x1, y1, …] list through one 2x3 affine per vertex (points or offsets). */
import { affine } from '@pose2d/math/affine';
import { POSE_LAYOUT } from '@pose2d/core/contracts/pose';

const STRIDE = POSE_LAYOUT.WORLD_STRIDE;

/** New number[]: pair k goes through the affine block of vertex `first + k` in `mats`; `linear` drops the translation. */
export function transformMeshPoints(flat: readonly number[], mats: Float64Array, first: number, linear: boolean): number[] {
  const out: number[] = [];
  const p: [number, number] = [0, 0];
  for (let k = 0; 2 * k + 1 < flat.length; k++) {
    const m = mats.subarray((first + k) * STRIDE, (first + k + 1) * STRIDE);
    const x = flat[2 * k] ?? 0;
    const y = flat[2 * k + 1] ?? 0;
    if (linear) affine.applyVec(m, x, y, p);
    else affine.apply(m, x, y, p);
    out.push(p[0], p[1]);
  }
  return out;
}
